export default __webpack_public_path__ + "static/media/3-5-2.852ebed8.jpg";